import {
  language_content_init
} from '@/base/base';
import {basic_language_new_style} from "@/base/widgets_data_compatible";
export default {
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  pc_infor:{
    marginTop:'0',
    marginLeft:'0',
    marginRight:'0',
    marginBottom:'0',
    textAlign: 'center'
  },
  mb_infor:{
    marginTop:'0',
    marginLeft:'0',
    marginRight:'0',
    marginBottom:'0',
    textAlign: 'center'
  },
  pc_widgets_infor: {
    //文字样式
    text_style: {
      radio_val: 'default',
      default: {
        fontFamily: 'Arial',
        fontSize: 12,
        color: 'rgba(33,33,33, 1)',
        fontWeight: 'normal',
        fontStyle: 'normal',
        textDecoration: 'none',
        selectColor: 'rgba(33,33,33, 1)',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(33,33,33,1)",
          end_color: "rgba(33,33,33,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 0
        },
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(33,33,33,1)",
          end_color: "rgba(33,33,33,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 0
        }
      },
      custom: {
        fontFamily: 'Arial',
        fontSize: 12,
        color: 'rgba(33,33,33, 1)',
        fontWeight: 'normal',
        fontStyle: 'normal',
        textDecoration: 'none',
        selectColor: 'rgba(33,33,33, 1)',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(33,33,33,1)",
          end_color: "rgba(33,33,33,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 0
        },
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(33,33,33,1)",
          end_color: "rgba(33,33,33,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 0
        }
      }
    },
    ...basic_language_new_style().background
  },
  mb_widgets_infor: {
    position: 'left', // left 顶部  right 底部
  },
  listArr: {
    styleType: 'dropdown', // dropdown 下拉式 expansion 横向 pop 弹框
    navigationItems: 'all', // all 文字和图标都有 icon 图标 word 文字
    position: 'header', // header 顶部  footer 底部
    content_set: { // 显示内容
      radio_val: 'default',
      default: {...language_content_init},
      custom: {...language_content_init}
    }
  },
}



// WEBPACK FOOTER //
// ./src/widgets/basic_language/style.js